import { TableTheme } from './DataTable.types';
import merge from 'deepmerge';

export const defaultDataTableTheme: TableTheme = {};

export const createTableTheme = (customTheme: TableTheme = {}): TableTheme =>
  merge(defaultDataTableTheme, customTheme);
